module.exports = __webpack_public_path__ + "img/none-icon.0c339c42.svg";